import React, { useState, useEffect, useContext } from 'react';
import { useSiteData } from 'react-static';
import { ThemeContext } from 'styled-components';
// template components
import SectionVideoPlayer from '@nmx/template/dist/componentLibrary/modules/SectionVideoPlayer';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import backgroundImageDesktop from '../../../../../images/components/sectionVideoPlayer/family-playing-by-golden-gate-bridge.webp';
import backgroundImageTablet from '../../../../../images/components/sectionVideoPlayer/family-playing-by-golden-gate-bridge-tablet.webp';

export default () => {
  const { config } = useSiteData();

  const theme = useContext(ThemeContext);
  const largeDown = theme.largeDown();
  const [isLargeDown, setIsLargeDown] = useState(largeDown);

  useEffect(() => {
    if (largeDown !== isLargeDown) {
      setIsLargeDown(largeDown);
    }
  }, [largeDown, isLargeDown]);

  return (
    <SectionVideoPlayer
      sectionId='retirement-planning-guide-video'
      backgroundImage={isLargeDown ? backgroundImageTablet : backgroundImageDesktop}
      config={config}
      playButtonSupportiveText='Watch the video'
      duration='2m 21s'
      durationDisplay='2 min' // round to nearest minute from duration
      videoId='_5AvoKDWEls'
      videoTitle={<>Let&#39;s take a look at ways you can maximize saving for retirement.</>}
      title={<>Let&#39;s take a look at ways you can maximize saving <WidowBlock>for retirement.</WidowBlock></>}
    />
  );
};
